export function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
}

export type Order = "asc" | "desc";

export function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (a: { [key in Key]: number | string | null }, b: { [key in Key]: number | string }) => number {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort(
  array: any[],
  comparator: (a: any, b: any) => number,
  filters?: { [k: string]: string | number }
) {
  if (filters !== undefined)
    array = array.filter((a) => {
      let ret = true;

      Object.entries(a).forEach((kv) => {
        const k = kv[0];
        if (k in filters && k in a) {
          const filter = filters[k];

          const element = kv[1];
          if (filter) {
            if (typeof element === "number")
              ret = ret && element.toString().includes(filter.toString());
            else if (typeof element === "string")
              ret = ret && element.toLowerCase().includes(filter.toString().toLowerCase());
          }
        }
      });

      return ret;
    });

  const stabilizedThis = array.map((el, index) => [el, index] as [any, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
